export default {
  'common.save': '保存',
  'common.cancel': '取消',
  'common.delete': '删除',
  'common.edit': '编辑',
  'common.confirm': '确认',
  'common.close': '关闭',
  'common.search': '搜索',
  'common.loading': '加载中...',
  'common.processing': '处理中...',
  'common.submit': '提交',
  'common.back': '返回',
  'common.next': '下一步',
  'common.previous': '上一步',
  'common.upload': '上传',
  'common.download': '下载',
  'common.downloadAll': '全部下载',
  'common.refresh': '刷新',
  'common.retry': '重试',
  'common.copy': '复制',
  'common.copied': '已复制',
  'common.selectAll': '全选',
  'common.clear': '清除',
  'common.clearAll': '全部清除',
  'common.apply': '应用',
  'common.reset': '重置',
  'common.filter': '筛选',
  'common.sort': '排序',
  'common.export': '导出',
  'common.import': '导入',
  'common.preview': '预览',
  'common.view': '查看',
  'common.add': '添加',
  'common.remove': '移除',
  'common.rename': '重命名',
  'common.share': '分享',
  'common.settings': '设置',
  'common.logout': '退出登录',
  'common.profile': '个人资料',
  'common.yes': '是',
  'common.no': '否',
  'common.ok': '确定',
  'common.areYouSure': '您确定吗？',
  'common.actionCannotBeUndone': '此操作无法撤销。',
  'common.noData': '暂无数据',
  'common.noResultsFound': '未找到结果',
  'common.somethingWentWrong': '出错了',
  'common.pleaseTryAgain': '请重试',
  'common.success': '成功',
  'common.error': '错误',
  'common.warning': '警告',
  'common.info': '信息',
  'common.optional': '选填',
  'common.required': '必填',
  'common.name': '名称',
  'common.title': '标题',
  'common.description': '描述',
  'common.status': '状态',
  'common.actions': '操作',
  'common.date': '日期',
  'common.time': '时间',
  'common.createdAt': '创建时间',
  'common.updatedAt': '更新时间',
  'common.type': '类型',
  'common.size': '大小',
  'common.file': '文件',
  'common.folder': '文件夹',
  'common.files': '文件',
  'common.folders': '文件夹',
  'common.all': '全部',
  'common.none': '无',
  'common.send': '发送',
  'common.sending': '发送中...',
  'common.new': '新建',
  'common.create': '创建',
  'common.duplicate': '复制',
  'common.move': '移动',
  'common.moveTo': '移动到',
  'common.selectFile': '选择文件',
  'common.chooseFile': '选择文件',
  'common.dragDropFilesHere': '将文件拖放到此处',
  'common.or': '或',
  'common.browse': '浏览',
  'common.continue': '继续',
  'common.skip': '跳过',
  'common.done': '完成',
  'common.finish': '完成',
  'common.start': '开始',
  'common.stop': '停止',
  'common.pause': '暂停',
  'common.resume': '恢复',
  'common.enabled': '已启用',
  'common.disabled': '已禁用',
  'common.active': '启用',
  'common.inactive': '未启用',
  'common.draft': '草稿',
  'common.published': '已发布',
  'common.archive': '归档',
  'common.unarchive': '取消归档',
  'common.favourite': '收藏',
  'common.favourites': '收藏夹',
  'common.pin': '置顶',
  'common.unpin': '取消置顶',
  'common.expand': '展开',
  'common.collapse': '收起',
  'common.showMore': '显示更多',
  'common.showLess': '收起更多',
  'common.language': '语言',
  'common.darkMode': '深色模式',
  'common.lightMode': '浅色模式',
  'common.help': '帮助',
  'common.feedback': '反馈',
  'common.notifications': '通知',
  'common.rows': '行',
  'common.column': '列',
  'common.total': '总计',
  'common.page': '页',
  'common.of': '/',
  'common.notes': '备注',
};
